<!--<nav class="navbar navbar-expand-lg navbar-light bg-light">-->
<!--  <a class="navbar-brand" href="javascript:void(0)">Items</a>-->
<!--</nav>-->
<h6>Items</h6>

<div class="scroll-box">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort
    matSortActive="sort_order" matSortDirection="asc" matSortDisableClear>

    <ng-container matColumnDef="icon">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let item">
        <mat-icon [ngClass]="item.pivot.status.toLowerCase()">
          {{ getIcon(item) }}
        </mat-icon>
      </td>
    </ng-container>

    <ng-container matColumnDef="status">
      <th mat-header-cell *matHeaderCellDef >Status</th>
      <td mat-cell *matCellDef="let item">
        {{ item.pivot?.status }}
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header [style.width.px]="250">
        Name
      </th>
      <td mat-cell *matCellDef="let item" class="no-padding">
        {{ item.name }}
      </td>
    </ng-container>

    <ng-container matColumnDef="requireDocuments">
      <th mat-header-cell *matHeaderCellDef class="no-padding">
        Require Documents
      </th>
      <td mat-cell *matCellDef="let item" class="no-padding">
        {{ item.pivot?.answer == 'NA' ? 'Not Applicable' : item.pivot?.answer }}
      </td>
    </ng-container>

    <ng-container matColumnDef="expiry">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header [style.width.px]="160">Expiry</th>
      <td mat-cell *matCellDef="let item" class="no-padding">
        <span *ngIf="item.pivot?.expiry">
          <p [ngClass]="getExpiryClass(item.pivot?.expiry)">{{ (item.pivot?.expiry * 1000) | timezoneConvertShort }}</p>
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="expiry_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header [style.width.px]="160">Expiry (UTC)</th>
      <td mat-cell *matCellDef="let item" class="no-padding">
        <span *ngIf="item.pivot?.expiry">
          {{ (item.pivot?.expiry * 1000) | timezoneConvertUTCShort }}
        </span>
      </td>
    </ng-container>

    <ng-container matColumnDef="rating">
      <th mat-header-cell *matHeaderCellDef class="no-padding" [style.width.px]="160">Rating</th>
      <td mat-cell *matCellDef="let item" class="no-padding" style="white-space: nowrap;">
        <app-rating [rating]="item.pivot?.rating" [edit]="app.account.isMasterAccount() && canEditPreQualifications"
          (ratingChanged)="ratePivot(item.pivot?.id, $event)"></app-rating>
      </td>
    </ng-container>

    <ng-container matColumnDef="notes">
      <th mat-header-cell *matHeaderCellDef class="no-padding" >
        Notes
      </th>
      <td mat-cell *matCellDef="let item" class="no-padding text-wrap">
        {{ item.pivot.notes }}
      </td>
    </ng-container>

    <ng-container matColumnDef="updated_by_user">
      <th mat-header-cell *matHeaderCellDef class="no-padding" >
        Updated By
      </th>
      <td mat-cell *matCellDef="let item" class="no-padding text-wrap">
        {{ item.pivot?.updated_by_user?.contact_person }}
      </td>
    </ng-container>

    <ng-container matColumnDef="updated_at">
      <th mat-header-cell *matHeaderCellDef class="no-padding" >
        Last Updated At
      </th>
      <td mat-cell *matCellDef="let item" class="no-padding text-wrap">
        <p *ngIf="item.pivot?.date_modified">{{ (item.pivot?.date_modified * 1000) | timezoneConvertMedium }}</p>
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="300">Actions</th>
      <td mat-cell *matCellDef="let item">

        <button type="button" mat-button (click)="onView(item.pivot?.id)">
          View
        </button>

        <button type="button" mat-button (click)="onEdit(item.pivot?.id)" *ngIf="app.account.isMasterAccount() && canEditPreQualifications">
          Edit
        </button>

        <button type="button" mat-button *ngIf="item.pivot.status !== 'Approved' && app.account.isMasterAccount() && canEditPreQualifications" (click)="onApprove(item, $event)">
          Approve
        </button>

        <button type="button" mat-button *ngIf="item.pivot.status !== 'Required' && app.account.isMasterAccount() && canEditPreQualifications" (click)="onReject(item, $event)">
          Reject
        </button>

      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit" [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons></mat-paginator>
</div>
